export default [
    {
      name: "rank",
      sortField: "rank",
      title: "Rankning",
      width: "1%",
      formatter: (value) => {
        switch (value) {
          case 1:
            return `<span style="font-size: 35px;" title="Men är det värt det?">🥇</span>`;
          case 2:
            return `<span style="font-size: 30px;" title="Andraplats är förstaplats!">🥈</span>`;
          case 3:
            return `<span style="font-size: 25px;" title="Troligare godare än 1:an och 2:an">🥉</span>`;
          case 69:
            // Nice
            return `<span style="position: relative; display: inline-block;"><b style="font-size: 20px;">${value}</b><sup style="position: absolute; top: -1px; right: -17px; font-size: 8px;"><i>nice</i></sup></span>`
          default:  
            return `<b style="font-size: 20px;">${value}</b>`;
        }
      }
    },
    {
        name: 'name',
        sortField: 'name',
        title: "Namn",
        width: "16.5%",
    },
    {
        name: "apk",
        sortField: "apk",
        title: "<abbr title=\"Aklohol Per Krona\">APK</abbr>",
        width: "15%",
        formatter: (value) => {
            // Avrundar till gällande siffror och sätter . -> ,
            return value.toFixed(2).toString().replace(".", ",") + "&nbsp;ml"
        }
    },
    {
        name: "pps",
        sortField: "apk", // För att de odefinierade ska funka
        title: "<abbr title=\"Pris Per Shot\">PPS</abbr> (4 cl 40%)",
        width: "12%",
    },
    {
        name: "price",
        sortField: "price",
        title: "Billigast enhetspris",
        width: "10%",
        formatter: (value) => {
            return value.toString().replace(".", ",") + "&nbsp;SEK"
        }
    },                
    {
        name: "alcvol",
        sortField: "alcvol",
        title: "Volymprocent",
        width: "8.0%",
        formatter: (value) => {
            return value.toString().replace(".", ",") + "%"
        }
    },
    {
        name: "volume",
        sortField: "volume",
        title: "Volym",
        width: "6%",
        formatter: (value) => {
            return value.toString().replace(".", ",") + "&nbsp;cl"
        }
    },
    {
        name: "category",
        sortField: "category",
        title: "Kategori",
        width: "10.5%",
    },
    {
        name: "subcategory",
        sortField: "subcategory",
        title: "Underkategori",
        width: "12.5%",
    },                                
]
